<template>
  <div class="vertical-layout h-100" :class="[layoutClasses]" :data-col="isNavMenuHidden ? '1-column' : null">

    <!-- Navbar -->
    <nav class="header-navbar navbar navbar-shadow align-items-center navbar-expand " :class="[navbarTypeClass]">

      <section class="container-fluid ">
        <slot name="navbar" :toggleVerticalMenuActive="toggleVerticalMenuActive"
          :navbarBackgroundColor="navbarBackgroundColor"
          :navbarTypeClass="[...navbarTypeClass, 'header-navbar navbar navbar-shadow align-items-center']">

          <app-navbar-vertical-layout :toggle-vertical-menu-active="toggleVerticalMenuActive"
            :is-vertical-menu-active="isVerticalMenuActive" />
        </slot>
      </section>

    </nav>
    <!--/ Navbar -->

    <!-- Vertical Nav Menu -->
    <vertical-nav-menu v-if="!isNavMenuHidden" :is-vertical-menu-active="isVerticalMenuActive"
      :toggle-vertical-menu-active="toggleVerticalMenuActive" :nav-menu-items="navMenuItems" id="menu-vertical-tour">

      <template #header="slotProps">
        <slot name="vertical-menu-header" v-bind="slotProps">
        </slot>
      </template>

    </vertical-nav-menu>
    <!-- /Vertical Nav Menu -->


    <!-- Vertical Nav Menu Overlay -->
    <div class="sidenav-overlay" :class="overlayClasses" @click="isVerticalMenuActive = false">
    </div>
    <!-- /Vertical Nav Menu Overlay -->

    <!-- Content -->

    <layout-content-renderer-default>
      <template v-for="(name, index) in Object.keys($slots)" v-slot:[name]="data">
        <slot :name="name" v-bind="data" />
      </template>
    </layout-content-renderer-default>


    <!--/ Content -->

    <!-- Footer -->
    <footer class="footer footer-light" :class="[footerTypeClass]">
      <slot name="footer">
        <app-footer />
      </slot>
    </footer>
    <!-- /Footer -->

    <slot name="customizer" />
  </div>
</template>

<script setup>


import AppNavbarVerticalLayout from '@layouts/components/app-navbar/AppNavbarVerticalLayout.vue'
import AppFooter from '@layouts/components/AppFooter.vue'
import useAppConfig from '@/app-config/useAppConfig'
import LayoutContentRendererDefault from '@layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import useVerticalLayout from './useVerticalLayout';

const props = defineProps({
  navMenuItems: {
    type: Array,
    required: true,
  },
});


const layoutContentRenderer = computed(() => {
  return LayoutContentRendererDefault;
});

const {
  routerTransition, navbarBackgroundColor, navbarType, footerType, isNavMenuHidden,
} = useAppConfig();

const {
  isVerticalMenuActive,
  toggleVerticalMenuActive,
  isVerticalMenuCollapsed,
  layoutClasses,
  overlayClasses,
  resizeHandler,
  navbarTypeClass,
  footerTypeClass,
} = useVerticalLayout(navbarType, footerType)

// Resize handler
resizeHandler()
window.addEventListener('resize', resizeHandler)
onUnmounted(() => window.removeEventListener('resize', resizeHandler))

</script>

<style lang="scss">
@use "@variables/variables" as *;
@import "@/assets/scss/base/themes/bordered-layout.scss";

.header-navbar {
  background: $color-fondo-menu !important;
  overflow: visible;

  .container-fluid {
    padding: 0rem 10px;

    @include media-breakpoint-up(sm) {
      padding: 0.2rem 1.4rem;
    }
  }
}
</style>